import { component } from 'picoapp';
import { createElement } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import ProductCompareButton from './ProductCompareButton';
import ProductComparisonDrawer from './ProductComparisonDrawer';
import './ComparisonDrawer.scss';
import ProductComparisonResults from './ProductComparisonResults';

export default component((node, ctx) => {
  /**
   * Product Comparion Drawer
   */
  if (!customElements.get('product-comparison-drawer')) {
    customElements.define(
      'product-comparison-drawer',
      class extends HTMLElement {
        connectedCallback() {
          const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
          render(createElement(ProductComparisonDrawer, Object.fromEntries(props)), this);
        }
      }
    );
  }

  /**
   * Button to add product to comparison
   */
  if (!customElements.get('product-compare-button')) {
    customElements.define(
      'product-compare-button',
      class extends HTMLElement {
        connectedCallback() {
          const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
          render(createElement(ProductCompareButton, Object.fromEntries(props)), this);
        }
      }
    );
  }

  /**
   * Component to hold the overal comparison results
   */
  if (!customElements.get('product-comparison-results')) {
    customElements.define(
      'product-comparison-results',
      class extends HTMLElement {
        connectedCallback() {
          const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
          render(createElement(ProductComparisonResults, Object.fromEntries(props)), this);
        }
      }
    );
  }
});
